import { InteractionRequiredAuthError } from '@azure/msal-browser';

export const getAccessToken = async ({ instance, account, scopes }) => {
  try {
    const res = await instance.acquireTokenSilent({ scopes, account });
    return res.accessToken;
  } catch (e1) {
    try {
      const res = await instance.acquireTokenSilent({ scopes, account, forceRefresh: true });
      return res.accessToken;
    } catch (e2) {
      if (
        e2 instanceof InteractionRequiredAuthError ||
        ['consent_required', 'interaction_required', 'login_required'].includes(e2?.errorCode)
      ) {
        // Use redirect instead of popup to avoid popup loops, especially on mobile
        const res = await instance.acquireTokenRedirect({ scopes });
        return res.accessToken;
      }
      throw e2;
    }
  }
};

export const fetchGraphMe = async ({ accessToken, select }) => {
  const selectQuery = select ? `?$select=${select}` : '';
  const response = await fetch(`https://graph.microsoft.com/v1.0/me${selectQuery}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (!response.ok) {
    throw new Error(`Graph /me failed: ${response.status}`);
  }
  return response.json();
};
